import { bl_svc_issue_request_attachment_RowClass } from '../../../dbschema/bl_svc_issue_request_attachment.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceNoteIssueRequestAttchmentContainerModel extends BaseContainerModel {
  bl_svc_issue_request_attachment: bl_svc_issue_request_attachment_RowClass = new bl_svc_issue_request_attachment_RowClass();
}
